/* Mavaro — en-tête : collant, menus, recherche prédictive */
(function () {
  'use strict';
  if (customElements.get('mavt-header')) return;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  class MavtHeader extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.sticky;
      if (this.mode !== 'none') this.initSticky();
      this.initMenus();
      this.initSearch();
      this.updateHeight();
      window.addEventListener('resize', () => this.updateHeight(), { passive: true });
    }

    updateHeight() {
      document.documentElement.style.setProperty('--header-height', this.offsetHeight + 'px');
    }

    initSticky() {
      // le conteneur de section devient collant pour que l'en-tête reste au-dessus du contenu
      const host = this.closest('.shopify-section') || this;
      host.style.position = 'sticky';
      host.style.top = '0';
      host.style.zIndex = '50';
      if (this.mode === 'always') return;
      let last = window.scrollY;
      host.style.transition = 'transform .25s ease-out';
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        if (y > last && y > this.offsetHeight + 50) {
          host.style.transform = 'translateY(-100%)';
          this.closeDropdowns();
        } else {
          host.style.transform = '';
        }
        last = y;
      }, { passive: true });
    }

    closeDropdowns() {
      this.querySelectorAll('.mavt-header__dropdown[open]').forEach((d) => d.removeAttribute('open'));
    }

    initMenus() {
      // un seul sous-menu ouvert à la fois, fermeture au clic extérieur
      this.querySelectorAll('.mavt-header__dropdown').forEach((d) => {
        d.addEventListener('toggle', () => {
          if (d.open) this.querySelectorAll('.mavt-header__dropdown[open]').forEach((o) => { if (o !== d) o.removeAttribute('open'); });
        });
        d.parentElement.addEventListener('mouseleave', () => d.removeAttribute('open'));
      });
      document.addEventListener('click', (e) => { if (!e.target.closest('.mavt-header__dropdown')) this.closeDropdowns(); });

      const drawer = this.querySelector('[data-mavt-menu-drawer]');
      const burger = this.querySelector('[data-mavt-menu-open]');
      if (drawer && burger) {
        burger.addEventListener('click', () => {
          drawer.hidden = false;
          burger.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('mavt-scroll-lock');
        });
        drawer.querySelectorAll('[data-mavt-menu-close]').forEach((b) => b.addEventListener('click', () => {
          drawer.hidden = true;
          burger.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('mavt-scroll-lock');
        }));
      }
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        this.closeDropdowns();
        if (drawer && !drawer.hidden) drawer.querySelector('[data-mavt-menu-close]').click();
        const modal = this.querySelector('[data-mavt-search-modal]');
        if (modal && !modal.hidden) this.closeSearch();
      });
    }

    initSearch() {
      const modal = this.querySelector('[data-mavt-search-modal]');
      if (!modal) return;
      this.searchModal = modal;
      const input = modal.querySelector('[data-mavt-search-input]');
      const results = modal.querySelector('[data-mavt-search-results]');
      this.querySelectorAll('[data-mavt-search-open]').forEach((b) => b.addEventListener('click', () => {
        modal.hidden = false;
        document.documentElement.classList.add('mavt-scroll-lock');
        setTimeout(() => input.focus(), 30);
      }));
      modal.querySelectorAll('[data-mavt-search-close]').forEach((b) => b.addEventListener('click', () => this.closeSearch()));

      let timer, controller;
      input.addEventListener('input', () => {
        clearTimeout(timer);
        const q = input.value.trim();
        if (!q) { results.innerHTML = ''; return; }
        timer = setTimeout(async () => {
          if (controller) controller.abort();
          controller = new AbortController();
          try {
            const url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,collection&resources[limit]=6&resources[options][unavailable_products]=last';
            const res = await fetch(url, { signal: controller.signal });
            const data = await res.json();
            const r = data.resources.results;
            const items = [].concat(
              (r.products || []).map((p) => ({ url: p.url, title: p.title, img: p.featured_image && p.featured_image.url, price: p.price })),
              (r.collections || []).map((c) => ({ url: c.url, title: c.title })),
              (r.pages || []).map((p) => ({ url: p.url, title: p.title }))
            );
            const esc = (s) => String(s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
            results.innerHTML = items.length
              ? '<ul class="mavt-search-results" role="list">' + items.map((i) =>
                  '<li><a class="mavt-search-result" href="' + esc(i.url) + '">' +
                  (i.img ? '<img src="' + esc(i.img) + (i.img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '') +
                  '<span><span class="mavt-search-result__title">' + esc(i.title) + '</span>' +
                  (i.price ? '<br><span class="mavt-search-result__price">' + esc(i.price) + ' €</span>' : '') +
                  '</span></a></li>').join('') + '</ul>' +
                '<a class="mavt-search-all" href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '&options[prefix]=last">Voir tous les résultats pour « ' + esc(q) + ' »</a>'
              : '<p>Aucun résultat pour « ' + esc(q) + ' »</p>';
          } catch (e) { /* requête annulée */ }
        }, 250);
      });
    }

    closeSearch() {
      if (!this.searchModal) return;
      this.searchModal.hidden = true;
      document.documentElement.classList.remove('mavt-scroll-lock');
    }
  }
  customElements.define('mavt-header', MavtHeader);
})();
